import React, { ComponentType, Fragment } from 'react';

export default function ItemsList<T>({
  items,
  renderItem,
  Item,
  itemId = 'id' as any,
  bottom,
}: {
  items: T[];
  renderItem?: (item: T) => React.ReactNode;
  bottom?: React.ReactNode;
  Item?: ComponentType<{ value: T }>;
  itemId?: keyof T;
  gapItems?: boolean;
  className?: string;
}) {
  return (
    <>
      {items.map((i) => (
        <Fragment key={i[itemId] as unknown as string}>
          {renderItem && renderItem(i)}
          {Item && <Item value={i} />}
        </Fragment>
      ))}
      {bottom}
    </>
  );
}
